/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Status_Pulling_Latest_CommitInputs */

const en_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulling latest commit...`)
};

const fr_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération du dernier commit...`)
};

const de_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der neueste Commit wird abgerufen...`)
};

const it_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione dell'ultimo commit...`)
};

const ru_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка последнего коммита...`)
};

const es_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrayendo el último commit...`)
};

const zh_cn2_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在拉取最新提交...`)
};

const ja_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のコミットをプルしています...`)
};

const hi_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम कमिट को पुल किया जा रहा है...`)
};

const pt_pt2_team_project_import_status_pulling_latest_commit = /** @type {(inputs: Team_Project_Import_Status_Pulling_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtendo o commit mais recente...`)
};

/**
* | output |
* | --- |
* | "Pulling latest commit..." |
*
* @param {Team_Project_Import_Status_Pulling_Latest_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_status_pulling_latest_commit = /** @type {((inputs?: Team_Project_Import_Status_Pulling_Latest_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Status_Pulling_Latest_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "de") return de_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "it") return it_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "ru") return ru_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "es") return es_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "ja") return ja_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "hi") return hi_team_project_import_status_pulling_latest_commit(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_status_pulling_latest_commit(inputs)
	return en_team_project_import_status_pulling_latest_commit(inputs)
});